export interface Deliveries {
  deliveryEvents: InitialDeliveryEvents[];
}

export enum DeliveryEventsType {
  GET_DELIVERY_EVENTS = 'GET_DELIVERY_EVENTS',
}

export interface InitialDeliveryEvents {
  orderId?: string;
  deliveryId?: string;
  problemDescription?: string;
  status?: string;
  eventType: string;
  timestamp: Date;
  deletedAt?: Date;
}
